import { apiService } from './api';

const API = '/automobile/invoices';

export const autoMobileInvoiceService = {
  getAll: (params?: { pageNumber?: number; pageSize?: number; status?: string }) =>
    apiService.get<any>(API, params),
  getById: (id: number) => apiService.get<any>(`${API}/${id}`),
  create: (data: any) => apiService.post<any>(API, data),
  update: (id: number, data: any) => apiService.put<any>(`${API}/${id}`, data),
  issue: (id: number) => apiService.post<any>(`${API}/${id}/issue`, {}),
  pay: (id: number, data: { amountPaid: number; paymentMethod: string }) =>
    apiService.post<any>(`${API}/${id}/pay`, data),
  void: (id: number, reason: string) => apiService.post<any>(`${API}/${id}/void`, { reason }),
};
